import { type ReactNode } from 'react';

import { emQuanto, formatarProxima } from '@/lib/fuso';
import { useAgoraPorMinuto } from '@/lib/relogio';
import { type EstadoCaptura } from '@fiscoai/contracts';

/** Rótulo + valor em linha, denso: o rótulo em tom fraco, o valor com número tabular. */
export function Dado({ rotulo, children }: { rotulo: string; children: ReactNode }) {
  return (
    <div className="flex min-w-0 items-baseline gap-2 text-sm">
      <dt className="shrink-0 text-texto-fraco">{rotulo}</dt>
      <dd className="tabular min-w-0 truncate text-texto">{children}</dd>
    </div>
  );
}

/**
 * Última e próxima busca no relógio da instalação ("hoje 16:45 · em 38 min"). Renderiza de novo a
 * cada virada de minuto para o "em X min" e o "hoje/amanhã" não envelhecerem na tela.
 */
export function UltimaProxima({ estado }: { estado: EstadoCaptura }) {
  const agora = new Date(useAgoraPorMinuto());
  const { ultimaExecucaoEm: ultima, proximaExecucaoEm: proxima, fuso } = estado;
  return (
    <>
      <Dado rotulo="Última busca">
        {ultima ? (
          <time dateTime={ultima}>{formatarProxima(ultima, fuso, agora)}</time>
        ) : (
          <span className="text-texto-fraco">ainda não rodou</span>
        )}
      </Dado>
      <Dado rotulo="Próxima">
        {proxima ? (
          <time dateTime={proxima}>
            {formatarProxima(proxima, fuso, agora)}{' '}
            <span className="text-texto-suave">· {emQuanto(proxima, agora)}</span>
          </time>
        ) : (
          <span className="text-texto-fraco">nenhuma agendada</span>
        )}
      </Dado>
    </>
  );
}
